import { memo } from 'react'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { CloseIcon } from '../../ui/CloseIcon'
import s from './GigAssClose.module.sass'

/**
 * @description компонент кнопки закрытия
 */
const GigAssClose = memo<{ onClick: () => void }>(({ onClick }) => {
  const { isMobile } = useClientResponsive()

  return (
    <button className={s.closeButton} onClick={onClick}>
      <CloseIcon isMobile={isMobile} />
    </button>
  )
})

GigAssClose.displayName = 'GigAssistClose'

export default GigAssClose
